import useCopyClipboard from 'hooks/useCopyClipboard'
import { useEffect, useState } from 'react'
import { BiCopy as CopyIcon } from 'react-icons/bi'
import { AnalyticsDetailsLink } from 'types/analytics'
import { shortenAddress } from 'utils'

import DiagonalCurrencyPair from '../../DiagonalCurrencyPairLogo'
import { MouseoverTooltip } from '../../Tooltip'
import ExternalLink from '../Details/AssetHeader/ExternalLink'

type AnalyticsDetailsLinksProps = {
  links: AnalyticsDetailsLink[]
}

export default function AnalyticsDetailsLinks({ links }: AnalyticsDetailsLinksProps) {
  const [isCopied, copy] = useCopyClipboard()
  const [copiedAddress, setCopiedAddress] = useState<string | null>(null)

  const onCopy = (address: string) => {
    copy(address)
    setCopiedAddress(address)
  }

  useEffect(() => {
    if (!isCopied) {
      setCopiedAddress(null)
    }
  }, [isCopied])

  const tooltipTextFor = (address: string) => (isCopied && copiedAddress === address ? 'Copied!' : undefined)

  return (
    <div className="w-full rounded-lg bg-kodiak-bg-floating flex flex-col gap-4 py-5 px-4">
      <span className="text-2xl text-kodiak-text-primary font-medium">Links</span>

      <div className="flex flex-col gap-2">
        {links.map((link) => (
          <div key={link.address} className="flex justify-between gap-2">
            <div className="flex gap-2 items-center">
              {Array.isArray(link.imageURI) ? (
                link.imageURI.length >= 2 && link.imageURI[1] ? (
                  <DiagonalCurrencyPair logo0={link.imageURI[0]} logo1={link.imageURI[1]} />
                ) : link.imageURI[0] ? (
                  <img
                    src={link.imageURI[0]}
                    width={24}
                    height={24}
                    alt={link.name}
                    className="shrink-0 rounded-full"
                  />
                ) : null
              ) : link.imageURI ? (
                <img src={link.imageURI} width={24} height={24} alt={link.name} className="shrink-0 rounded-full" />
              ) : null}

              <span className="text-sm xl:max-w-[90px] max-w-[62px]">{link.name}</span>
            </div>

            <div className="flex items-center gap-2 min-w-[130px] justify-end">
              <MouseoverTooltip text={tooltipTextFor(link.address)} placement="top" showArrow={isCopied}>
                <div
                  className="flex gap-1 items-center !font-mono px-2 py-1 rounded-xl text-xs text-kodiak-text-secondary hover:text-kodiak-text-primary transition-all bg-kodiak-bg-module cursor-pointer min-h-10"
                  onClick={() => onCopy(link.address)}
                >
                  {shortenAddress(link.address)}

                  <CopyIcon color="#f8fafc" size={16} />
                </div>
              </MouseoverTooltip>

              <ExternalLink link={link.href} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
